/* eslint-disable max-lines */
import MarkdownIt from 'markdown-it';
import utils from '@/components/utils/common.js';
const year = utils.formatDateTime(new Date(), 'YYYY');

export const config = {
    name: 'paperDialog',
    columns: [
        {
            label: '',
            prop: 'categoryName'
        },
        {
            label: '客户全量规模(万元)',
            prop: 'customerTotalScale'
        },
        {
            label: '安得已合作规模(万元)',
            prop: 'cooperationScale'
        },
        {
            label: '安得未合作规模(万元)',
            prop: 'pendingCooperationScale'
        },
        {
            label: '未合作部分主要竞对手',
            prop: 'pendingMajorCompetitors'
        }
    ],
    // 多级表头
    columnsSecondary: [
        // 一级表头
        [
            {
                label: '分公司',
                prop: 'companyName',
                thProps: {
                    rowspan: 2
                }
            },
            {
                label: '业务类型',
                prop: 'businessCategory',
                thProps: {
                    rowspan: 2
                }
            },
            {
                label: `${year - 2}年`,
                prop: 'before2Y',
                thProps: {
                    colspan: 2
                }
            },
            {
                label: `${year - 1}年`,
                prop: 'before1Y',
                thProps: {
                    colspan: 2
                }
            },
            {
                label: `${year}年达成(截至上月)`,
                prop: 'before0Y',
                thProps: {
                    colspan: 2
                }
            }
        ],
        // 二级表头
        [
            {
                label: '收入(万元)',
                prop: 'totalIncomeBefore2Y'
            },
            {
                label: '经营中心利润率',
                prop: 'profitRateBefore2Y'
            },
            {
                label: '收入(万元)',
                prop: 'totalIncomeBefore1Y'
            },
            {
                label: '经营中心利润率',
                prop: 'profitRateBefore1Y'
            },
            {
                label: '收入(万元)',
                prop: 'totalIncomeBefore0Y'
            },
            {
                label: '经营中心利润率',
                prop: 'profitRateBefore0Y'
            }
        ]
    ],
    // 表尾合计
    columnsSummaries: [
        {
            label: '分公司',
            prop: 'companyName'
        },
        {
            label: '业务类型',
            prop: 'businessCategory'
        },
        {
            label: '收入(万元)',
            prop: 'totalIncomeBefore2Y'
        },
        {
            label: '经营中心利润率',
            prop: 'profitRateBefore2Y',
            calcField: ['totalProfitBefore2Y', 'totalIncomeBefore2Y']
        },
        {
            label: '收入(万元)',
            prop: 'totalIncomeBefore1Y'
        },
        {
            label: '经营中心利润率',
            prop: 'profitRateBefore1Y',
            calcField: ['totalProfitBefore1Y', 'totalIncomeBefore1Y']
        },
        {
            label: '收入(万元)',
            prop: 'totalIncomeBefore0Y'
        },
        {
            label: '经营中心利润率',
            prop: 'profitRateBefore0Y',
            calcField: ['totalProfitBefore0Y', 'totalIncomeBefore0Y']
        }
    ]
};

// markdown
export const markdownFormat = () => {
    const md = new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true
    });
    // 覆盖默认的 table 渲染规则
    md.renderer.rules.table_open = function (tokens, idx, options, env, self) {
        // 可以添加自定义属性，比如类名、data属性等
        return '<table style="border: 1px solid #000;border-collapse: collapse;width: 100%;color: #555;margin-bottom: 15px;">';
    };
    md.renderer.rules.table_close = function (tokens, idx, options, env, self) {
        return '</table>';
    };
    // 也可以修改其他表格相关元素的规则
    md.renderer.rules.th_open = function (tokens, idx, options, env, self) {
        return `<th style="border: 1px solid #000;padding: 0px 6px;background-color: #EBEEF5;color: #000;height: 23px;font-size: 12px;font-weight: normal;text-align: left;">`;
    };
    md.renderer.rules.td_open = function (tokens, idx, options, env, self) {
        const token = tokens[idx];
        // 可以基于 token 属性进行条件渲染
        const align = token.attrGet('style');
        const className = align ? `td-align-${align.replace('text-align:', '')}` : '';
        return `<td class="${className}" style="border: 1px solid #000;padding: 0px 6px;font-size: 12px;">`;
    };
    md.renderer.rules.table_cell = function (tokens, idx, options, env, slf) {
        const token = tokens[idx];
        // 检查是否为空单元格，并添加适当的样式或内容
        if (token.content.trim() === '') {
            return '<td>&nbsp;</td>'; // 使用非断格符来保持单元格宽度
        } else {
            return md.renderer.renderToken(tokens, idx, options);
        }
    };
    // // 2. 保存默认的段落渲染规则，以便后续调用
    // const defaultParagraphRender = md.renderer.rules.paragraph_open
    //     || function (tokens, idx, options, env, self) {
    //         return self.renderToken(tokens, idx, options);
    //     };
    // md.renderer.rules.paragraph_open = (tokens, idx, options, env, self) => {
    //     // 调用默认的渲染逻辑，得到原始的 <p> 标签字符串
    //     const originalOpenTag = defaultParagraphRender(tokens, idx, options, env, self);
    //     // 在 <p> 标签上添加行内样式，字体大小来自组件的 `fontSize` 属性
    //     const styledOpenTag = originalOpenTag.replace(
    //         /^<p>/,
    //         `<p style="font-size:12px;">`
    //     );
    //     return styledOpenTag;
    // };

    return md;
};

// 处理接口返回的带标签的数据
export const formatHtml = (content) => {
    if (!content) return '';
    const str = content.replace(/\\n|\n/g, '');
    // 创建临时DOM元素，利用浏览器原生解码能力
    const tempElement = document.createElement('div');
    tempElement.innerHTML = str;

    // 获取解码后的文本(会自动处理所有标准HTML实体)
    const decodedStr = tempElement.innerHTML;
    // const decodedStr = tempElement.textContent || tempElement.innerText;
    // 清空临时元素，避免内存泄漏
    tempElement.innerHTML = '';
    return decodedStr;
};

// 处理参考资料
export const formatDatasource = (str) => {
    const flag = '参考资料:';
    const data = str?.split(flag);
    const content = data?.slice(0, 1)?.join(flag);
    const result = data?.slice(1)?.join(flag)?.split(';');
    const datasource = result && result[0].length ? result.map((v) => {
        const obj = {};
        const source = v?.split('(http');
        obj.title = source?.slice(0, 1).join('(http');
        obj.link = 'http' + source?.slice(1)?.join('(http')?.slice(0, -1);
        return obj;
    }) : [];
    return { content, datasource };
};
